import React from 'react';
import { useSelector } from 'react-redux';

import { memo } from '../../../../../../../shared/assets/emojis'
import { greeting } from '../../../../../../../shared/utils/helpers/hosmanVars';

import { Emoji } from 'hosman-material';

const Greetings = () => {
  const { user } = useSelector((state) => state.user);
  const { currentStep } = useSelector((state) => state.sellerMandates);
  
  if (currentStep.number !== 1) return null;
  
  return (
    <p className='h2 text-ih-indigo text-center md:w-2/3 mx-auto' data-testid='Greetings'>Bonjour {greeting(user)}, vérifiez vos informations et signez votre mandat<span className='ml-3'><Emoji emojiSrc={memo} width='w-8' /></span></p>
  );
}

export default Greetings;
